import { render, staticRenderFns } from "./Treasure-management.vue?vue&type=template&id=050f086a&scoped=true&"
import script from "./Treasure-management.vue?vue&type=script&lang=js&"
export * from "./Treasure-management.vue?vue&type=script&lang=js&"
import style0 from "./Treasure-management.vue?vue&type=style&index=0&id=050f086a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f086a",
  null
  
)

export default component.exports